import React from "react";
import { NavLink } from "react-router-dom";
import { Menu } from "semantic-ui-react";

export default function Navigation() {
  return (
    <Menu secondary pointing>
      <Menu.Item
        as={NavLink}
        to="/app/action/status/list"
        name="Status Orders List"
      />
      <Menu.Item
        as={NavLink}
        to="/app/action/status/create"
        name="Create Status Order"
      />
    </Menu>
  );
}
